import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'news-card',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      '& h4': {},
      '&:hover': {
        '& $title': {
          color: theme.palette.secondary.main,
        },
        '& $image': {
          filter: 'drop-shadow(0px 4px 20px rgba(88, 108, 194, 0.2))',
        },
      },
    },
    image: {
      display: 'flex',
      transition: 'all .3s',
      '& img': {
        borderRadius: 8,
        width: '100%',
        height: 240,
        objectFit: 'cover',
      },
    },
    title: {
      transition: 'all .3s',
      color: theme.palette.text.primary,
    },
  }),
  options
);

export default useStyles;
